import {all} from 'redux-saga/effects';

import {createFetchSagaLatest} from 'utils/sagas';

import {fetchBookingsForBookingTracker as fetchBookingsForBookingTrackerAction} from './';

import {fetchBookingsForBookingTracker} from 'sdk/bookings';

function* bookingsTrackerSaga() {
  yield all([
    createFetchSagaLatest(
      fetchBookingsForBookingTrackerAction,
      fetchBookingsForBookingTracker
    )
  ]);
}

export default bookingsTrackerSaga;
